import React from "react";

import { processTextWithPhoneNumbers } from "../../../../../../utils/phoneUtils";
import { replaceLineBreaksByTag } from "../../../../../../services/utils";
import styles from "./textArea.scss";

const TextArea = ({ itemData, category, adId, hrPageName }) => {
  const gaEvent = {
    category: "Detalji oglasa",
    action: "Click",
    label: `Klik na telefon - ${hrPageName || ''}`
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{itemData.title}</div>
      <div className={styles.text}>
        {processTextWithPhoneNumbers(replaceLineBreaksByTag(itemData.value), gaEvent, adId)}
      </div>
    </div>
  );
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/TextArea/index.tsx